import appHelpers from 'utils/app-urls';

type RewardsTierDescriptionProps = {
  image: string;
  imageAltText: string;
  link: string;
  text: string;
};

export default function RewardsShareCard({
  image,
  imageAltText,
  link,
  text,
}: RewardsTierDescriptionProps) {
  const cdnURL = appHelpers.getCDNUrl();

  return (
    <div className="text-header-text sm:mx-3 mx-1 w-18">
      <div className="sm:justify-center">
        <a
          className="sm:p-1.5 sm:px-4 rounded-full text-sm text-header-text"
          href={`${link}`}
          target="_blank"
          rel="noopener noreferrer">
          <img
            src={`${cdnURL}${image}`}
            alt={imageAltText}
            className="center"
          />{' '}
        </a>
        <p className="pb-3 hidden xs:block sm:text-base text-xs text-center">
          {text}
        </p>
      </div>
    </div>
  );
}
